module.exports = __webpack_public_path__ + "img/313.246c8e26.png";